import React from 'react'
import PropTypes from 'prop-types'

import { YES_NO_OPTIONS } from 'utils/enums/questions'
import { FormRadioButtonGroup } from 'components/form/radioButtonGroup/FormRadioButtonGroup'
import { validateRequiredField } from 'utils/helpers/validators/byType/requiredField'

import styles from '../FormByState.module.scss'

export const DcFormConfig = {
  wasNotSubjectOfAbuse: {
    required: formData => !formData.unknownPerson.value,
    validator: validateRequiredField,
  },
  wasNotResigned: {
    required: formData => !formData.unknownPerson.value,
    validator: validateRequiredField,
  },
  wasNotLicenseRevoked: {
    required: formData => !formData.unknownPerson.value,
    validator: validateRequiredField,
  },
}

export const DCForm = ({ formData, handleFieldChange }) => (
  <div className={styles.form}>
    <FormRadioButtonGroup
      title="Has Applicant ever been the subject of any child abuse or sexual misconduct investigation by the employer, state licensing agency, law enforcement agency, or CFSA (or other state’s equivalent) that did not result in a finding that the allegations were false or the alleged incident was not substantiated?"
      className={styles.radioButtonQuestion}
      options={YES_NO_OPTIONS}
      field={formData.wasNotSubjectOfAbuse}
      handleFieldChange={handleFieldChange}
    />

    <FormRadioButtonGroup
      title="Has Applicant ever been disciplined, discharged, nonrenewed, asked to resign, resigned from or otherwise separated from employment while allegations of child abuse or sexual misconduct were pending or under investigation or due to an adjudication or finding of child abuse or misconduct?"
      className={styles.radioButtonQuestion}
      options={YES_NO_OPTIONS}
      field={formData.wasNotResigned}
      handleFieldChange={handleFieldChange}
    />

    <FormRadioButtonGroup
      title="Has Applicant ever had a license, professional license, or certificate suspended, surrendered or revoked while allegations of child abuse or sexual misconduct were pending or under investigation, or due to an adjudication or finding of child abuse or sexual misconduct?"
      className={styles.radioButtonQuestion}
      options={YES_NO_OPTIONS}
      field={formData.wasNotLicenseRevoked}
      handleFieldChange={handleFieldChange}
    />
  </div>
)

DCForm.propTypes = {
  formData: PropTypes.object.isRequired,
  formMeta: PropTypes.object.isRequired,
  handleFieldChange: PropTypes.func.isRequired,
}
